import React from 'react';

export default function Header() {
  return (
    <header className="bg-slate-900 border-b border-slate-800 sticky top-0 z-40 md:mt-16">
      <div className="max-w-screen-md mx-auto px-4 h-16 flex items-center justify-between">
        <div className="flex items-center space-x-2 sm:space-x-3 overflow-hidden pr-2">
          <img 
            src="https://media-manager-c.questera.ai/greta-media/0d1a77bee3ae789007ea5ef360df1d387ec1e85717a1017af2b0c3483a4e466cd39e9bbe534d979be486fb8af10a0ba5/images/aW1hZ2UvcG5n/11b010bae69044ed96a48a35b8d6c5bf.png" 
            alt="Elk Grove Airline Wait Logo" 
            className="h-8 sm:h-10 object-contain shrink-0"
          />
          <h1 className="font-sans font-bold text-[13px] sm:text-base tracking-tight leading-tight">
            Elk Grove <br className="sm:hidden" /><span className="text-amber-400">Airline Wait</span>
          </h1>
        </div>
        <div className="flex items-center space-x-2 text-[10px] sm:text-xs font-mono text-slate-400 bg-slate-850 px-2 py-1 rounded shrink-0">
          <div className="w-2 h-2 rounded-full bg-emerald-500 animate-pulse-slow"></div>
          <span>LIVE</span>
        </div>
      </div>
    </header>
  );
}